import { Injectable } from '@angular/core';
import {  Router, ActivatedRoute } from '@angular/router';
// import { User } from '../@core/data/model/user';
// import { Token } from '../@core/data/model/token';
// import {ApiEndpoints} from '../@core/data/rest/ApiEndpoints';
// import {ApiUtils} from '../@core/data/rest/ApiUtils';
import { plainToClass } from 'class-transformer';
// import { SharedMethods } from '../util/sharedMethods-service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
// import { FenetreService } from '../@core/utils/fenetre-service';
import { Token } from '../shared/data/token';
import { Config } from '../config/config';


const MINUTES_UNITL_AUTO_LOGOUT = 15 ; // in mins
const CHECK_INTERVAL = 15000; // in ms
const STORE_KEY =  'lastAction';


@Injectable()
export class AuthService {

  token: Token;

  isAuthenticating = false;

  redirect = '';

  permissionsToRedirect: string[];

  // isTenanTDBChange = false;

  
  credentiales: {

    login: string,
    password: string,

  };

  identifiant: any;

  // httpClient: any;

  constructor(private router: Router, private route: ActivatedRoute, public http: HttpClient) {

   this.identifiant = {
      login: '',
      password: '',
   };

    if (localStorage.getItem('cms_token') !== null && this.isTimeout)
    this.token = plainToClass(Token, JSON.parse(localStorage.getItem('cms_token')) as object);

  }

  public checkinterval(): number {
    return CHECK_INTERVAL;
  }

  public storekey(): string {
    return STORE_KEY;
  }

  public getLastAction() {
    // tslint:disable-next-line:radix
    return parseInt(localStorage.getItem(STORE_KEY));
  }

  public setLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }

  isTimeout(): boolean {
  
    const now = Date.now();

    let timeleft: number;

    timeleft = this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;

    const diff = timeleft - now;
    const timeout = diff < 0;
    return timeout;

  }

  authenticate() {

    this.isAuthenticating = true;

    const  body = {
        login: this.identifiant.login,
        password: this.identifiant.password,
    };

    // this.apiUtils.TENANTDB = this.credentiales.tenant;

    const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json'   
        })
    };

   
    var donnees = JSON.stringify(body);

    return this.http.post(Config.apiUrl+ 'login',donnees,httpOptions);

  }

  login() {

    if (localStorage.getItem('cms_token') !== null) {
      this.token = plainToClass(Token, JSON.parse(localStorage.getItem('cms_token')) as object);
      // this.apiUtils.CURRENT_ACCESS_TOKEN = this.token.value;
    }

    this.router.navigateByUrl("key");
    
    /* if ( this.isHavingPermission(this.permissionsToRedirect) ) {

     
      window.location.href = '#' + this.redirect;
      window.location.reload();

    } else {

      
      window.location.href = '#';
      window.location.reload();

    } */


  }

  logout() {

    // s'il s'agit d'une fenetre popup on la laisse connecter car sera fermé par la fenetre principale
    // Et on oubli pas de supprimer le localStorage de popup à la fin
    /* if (this.fenetreService.findnames(window.name) !== null )
    return; */

    if (this.router.url !== '/login') {
      this.redirect = this.router.url;
      // this.permissionsToRedirect = this.router.routerState.snapshot.root.data.permissions;
    }

    // localStorage.removeItem('cms_token');
    localStorage.clear();    
    

    this.token = null;
    this.identifiant.password = '';

    // localStorage.removeItem('popup');

    //console.log(this.permissionsToRedirect);

    this.router.navigate(['/login']);

  }

  isHavingPermission(permission: string[]): boolean {

    let result = false;

    if (permission === undefined )
    return true;

    // a parti d'ici on est sur que permission est différent de undefined
    if (this.token === undefined || this.token === null )
    return false;

    if (this.token.user.permissions !== undefined && this.token.user.permissions !== null) {

        const permissionValues = [];
        const permissionfind = [];
        for ( let i = 0; i < this.token.user.permissions.length; i++) {

           permissionValues.push(this.token.user.permissions[i]);
        }

        for ( let i = 0; i < permission.length; i++) {

            if (permissionValues.indexOf(permission[i])  > -1)
            permissionfind.push(permission[i]);
            // result = true;
        }

        // on compare
        if( permission.length === permissionfind.length  )
        result = true;


    }

    return result;

  }


  get userpicture(): string {

    if(this.token !== undefined && this.token !== null && this.token.user.photo !== null && this.token.user.photo !== undefined)
    return this.token.user.photo.url
    else
    return "";
  }

  get username(): string {

    if(this.token !== undefined && this.token !== null)
    return this.token.user.username
    else
    return "";
  }

 


}
